// Speed Control Import

// Take Notes Imports
import IconDownload from '@listening/assets/astro/icons/icon-download-note.svg?react';
import IconPencil from '@listening/assets/astro/icons/icon-pencil.svg?react';
import IconShare from '@listening/assets/astro/icons/icon-share.svg?react';
import * as m from '@/paraglide/messages';
import SpeedControlReact from './SpeedControl';

const notes = [
  {
    text: () => m.homepage_features_note_1_title(),
    subtext: () => m.homepage_features_note_1_description(),
  },
  {
    text: () => m.homepage_features_note_2_title(),
    subtext: () => m.homepage_features_note_2_description(),
  },
  {
    text: () => m.homepage_features_note_3_title(),
    subtext: () => m.homepage_features_note_3_description(),
  },
];

export function RowSecondFeatures() {
  return (
    <div className='grid grid-cols-1 gap-4 lg:grid-cols-3'>
      {/* <!-- Speed Control Section --> */}
      <div
        aria-labelledby='speed-control-title'
        className='flex flex-col rounded-xl bg-azure-525/10 p-4 sm:rounded-2xl sm:p-6 lg:p-8'
        role='region'
      >
        <div className='grow'>
          <SpeedControlReact />
        </div>

        <div className='mt-12'>
          <h3
            className='mb-3 text-2xl font-black text-navy-220 sm:text-2xl lg:mb-4 xl:text-3xl'
            id='speed-control-title'
          >
            {m.homepage_features_speed_title()}
          </h3>
          <p className='text-xs font-medium text-navy-220/70 sm:text-sm'>
            {m.homepage_features_speed_description()}
          </p>
        </div>
      </div>

      {/* <!-- Take Notes Section --> */}
      <div
        aria-labelledby='notes-title'
        className='overflow-hidden rounded-2xl bg-azure-525/10 p-8 lg:col-span-2 lg:p-12'
        role='region'
      >
        <div className='flex h-full flex-col'>
          <div className='relative mb-10 flex-1'>
            <div
              aria-label='Example notes'
              className='relative mx-auto flex w-full flex-col items-center justify-center gap-8 lg:h-[280px] lg:flex-row lg:gap-0 xl:gap-6'
              role='list'
            >
              {notes.map((note, index) => (
                <div
                  className={`mx-auto w-full rounded-[12px] border-[1.5px] border-white/16 bg-white/8 shadow-lg lg:w-[300px] ${
                    index === 0
                      ? 'lg:-translate-x-6 lg:translate-y-4 lg:rotate-[-8deg]'
                      : index === 1
                        ? 'lg:translate-y-0'
                        : 'lg:translate-x-6 lg:translate-y-4 lg:rotate-[8deg]'
                  } p-6 ${index !== 0 ? '-mt-4 lg:mt-0' : ''} transform-gpu will-change-transform`}
                  key={note.text()}
                  role='listitem'
                >
                  <div className='flex h-full flex-col gap-8'>
                    <div className='flex-1'>
                      <p className='mb-3 text-sm font-bold xl:text-xl'>
                        {note.text()}
                      </p>
                      <p className='text-sm font-light xl:text-base'>
                        {note.subtext()}
                      </p>
                    </div>
                    <div
                      aria-label='Note actions'
                      className='flex gap-4'
                      role='toolbar'
                    >
                      <div
                        aria-label='Edit note example'
                        className='rounded-lg p-2 transition-colors hover:bg-white/10'
                      >
                        <IconPencil aria-hidden='true' />
                      </div>
                      <div
                        aria-label='Share note example'
                        className='rounded-lg p-2 transition-colors hover:bg-white/10'
                      >
                        <IconShare aria-hidden='true' />
                      </div>
                      <div
                        aria-label='Download note example'
                        className='rounded-lg p-2 transition-colors hover:bg-white/10'
                      >
                        <IconDownload aria-hidden='true' />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className='mt-6 text-center lg:text-left'>
            <h3
              className='mb-4 text-2xl font-bold text-navy-220 xl:text-3xl'
              id='notes-title'
            >
              {m.homepage_features_notes_title()}
            </h3>
            <p className='text-sm font-medium text-navy-220/70'>
              {m.homepage_features_notes_description()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
